/*
 * Photo evidence uploader component
 * NOTE: Only works inside WebView in SmartME APP.
 */
import React from 'react';

import Base from './base.jsx'; 
import {
  DataType,
  castDataType,
} from '../common.jsx';
import Helpers from './helpers.jsx'
import Setting from "./setting.jsx";


export default class AdaliaMEMobilePhoto extends Base {

        static get CATEGORY() {
            return 'other';
        }

        static get TYPE() {
            return 'adalia_me_mobile_photo';
        }

        static icon(){
            return <i className="fa font fa-camera"></i>;//TODO change icon.
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                label: 'field_default_label',
                placeholder: 'field_default_placeholder',
                description: 'field_default_description',
                help: null,
                unit: null
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                label: 'label',
                placeholder: 'placeholder',
                description: 'description',
                name: 'field_' + Helpers.randomString(),
                reportKey: '',
                help: 'help',
                required: false,
                label_hidden: false
            });
        }

        renderView() {
            const answer = this.getAnswer();
            return (
                <div>
                    <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
                        <span className="field-label">{this.getText('label')}</span>
                        {this.props.content.required ? <span className='required-field'> *</span> : null}
                        {this.helpIcon()}
                        <div className="input-container">
                          <input id="mobile-photo-field" type='hidden' name={this.fullFieldName()}></input>
                          <p className="btn btn-primary take-photo">{I18n.t('take_photo')}</p>
                        </div>
                        {answer && answer.metadata
                        ? <a
                            href={answer.path}
                            data-av='true'
                            data-av-content-type={answer.metadata.filetype}
                          >
                            {answer.id}
                          </a>
                        : null}
                    </label>
                    {this.descriptionText()}
                </div>
            );
        }

        renderSettings() {
            return (
                <div>
                    <Setting.Checkbox name="required" label={I18n.t('field_required', {scope: 'fe'})} value={this.props.content.required} onChange={this.updateSettings} />
                    <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
                    <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
                    <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
                </div>
            );
        }

        beforeUpdateSettings(content) {
            content.required = castDataType(content.required, DataType.BOOLEAN);
            content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
        }
}
